const DEFAULT_ICON =
  "https://cdn.ninestatic.com/front/components/register/gift-icon.png?id=1";

const IMAGE_EXTENSIONS = [".png", ".jpg", ".jpeg", ".gif", ".webp", ".svg", ".avif"];

const hasImageExtension = (value) => {
  if (!value || typeof value !== "string") return false;
  const lower = value.toLowerCase();
  return IMAGE_EXTENSIONS.some((ext) => lower.endsWith(ext));
};

export const getBonusIconMeta = (campaign) => {
  const freeSpinImages = Array.isArray(campaign?.free_spin_game_images)
    ? campaign.free_spin_game_images
    : Array.isArray(campaign?.bonus_campaign?.free_spin_game_images)
      ? campaign.bonus_campaign.free_spin_game_images
      : [];
  if (freeSpinImages[0]) {
    return { src: freeSpinImages[0], isFallback: false };
  }

  const campaignImage =
    campaign?.campaign_image || campaign?.bonus_campaign?.campaign_image;
  if (hasImageExtension(campaignImage)) {
    return { src: campaignImage, isFallback: false };
  }

  return { src: DEFAULT_ICON, isFallback: true };
};

const getBonusIcon = (campaign) => getBonusIconMeta(campaign).src;

export default getBonusIcon;
